import styled from 'styled-components'

export const Container = styled.div`
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
    margin: 0;
    font-family: Avenir;
    display: grid;
    grid-template-columns: 95vw 5vw;
    grid-template-rows: auto;
    gap: 0px 0px;
    grid-template-areas: 'main side';
    background-color: #222;

    .main {
        grid-area: main;
    }

    .side {
        grid-area: side;
    }
`

export const Section = styled.div``

export const DummyArtefact = styled.div`
    background: #c84343;
    width: 100%;
    height: 100%;
`
export const TTMWrapper = styled.div``

export const TestNotificationsWrapper = styled.div`
    position: fixed;
    left: 100px;
    bottom: 50px;
    cursor: pointer;
`

export const TestNotificationsButton = styled.div`
    background-color: green;
    height: 40px;
`
